import type { Component, JSX, ParentComponent, VoidComponent } from "solid-js";
import { Show } from "solid-js";
import Text from "../../../../components/text/Text.tsx";
import { TextInput } from "../../../../components/inputs/TextInput.tsx";

type SettingValueProps = {
  label: string;
};

const SettingValue: ParentComponent<SettingValueProps> = (props) => (
  <div class="flex flex-col">
    <div class="text-base-semibold text-secondary">
      <Text as="p" text={props.label} truncate />
    </div>
    {props.children}
  </div>
);

type SettingTextValueProps = {
  children: string | NonNullable<JSX.Element>;
} & SettingValueProps;

export const SettingTextValue: Component<SettingTextValueProps> = (props) => (
  <SettingValue label={props.label}>
    <div class="text-base-regular text-primary">
      <Text as="p" text={props.children} truncate />
    </div>
  </SettingValue>
);

type EditableSettingTextValueProps = {
  text: string;
  editing: boolean;
  editValue?: string;
  editError?: string;
  editOnBlur: (value: string) => void;
  editDisabled?: boolean;
  required?: boolean;
} & SettingValueProps;

export const EditableSettingTextValue: VoidComponent<EditableSettingTextValueProps> = (props) => (
  <Show when={props.editing} fallback={<SettingTextValue label={props.label}>{props.text}</SettingTextValue>}>
    <TextInput
      onBlur={(e) => props.editOnBlur(e.currentTarget.value)}
      label={props.label}
      required={props.required}
      value={props.editValue ?? props.text}
      errorMessage={props.editError}
      disabled={props.editDisabled}
    />
  </Show>
);

export default SettingValue;
